module.exports = __webpack_public_path__ + "static/media/10d.85b0244d.svg";